import { useTranslation } from '@crehana/i18n';
import { useMemo } from 'react';
import locales, { type TKeys } from '../i18n';
import { PAGE_KEY } from '../i18n/constants';

export const useAddCommunityInternalCommsBundle = () => {
  const { addResourceBundle } = useTranslation();

  addResourceBundle(locales);
};

export const useCommunityInternalCommsTranslations = () => {
  const { t: t_primitive, languageCode } = useTranslation<TKeys>(PAGE_KEY);

  // biome-ignore lint/correctness/useExhaustiveDependencies: This prevents infinite re-renders
  const t = useMemo(() => {
    return t_primitive;
  }, []);

  return {
    t,
    languageCode,
  };
};
